export default __webpack_public_path__ + "static/media/ic_chevron_right.743df93c.svg";